module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('em', [_vm._v("Have I betrayed them all again by telling the story?")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', [_vm._v("Or is it the other way round:")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', [_vm._v("would I have betrayed them if I had not told it?")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("—AMOS OZ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f99750c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/fm1.vue
// module id = 72
// module chunks = 0